<template>
  <p>You are not authorized to see this page.</p>
</template>

<script>
export default {};
</script>

<style></style>
